import { Component } from '@angular/core';

import { stateService, viewService } from '@unpispas/upp-base';

/** Root shell for the Pinpad terminal app (`Access = 'LOGIN'`, `WorkMode = 'PTF'`). */
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
})
export class AppComponent {
    title = 'unpispas-ptf';

    constructor(public view: viewService, private state: stateService) {
        this.view.Access = 'LOGIN';
        this.state.WorkMode = 'PTF';
        this.view.AppProfile = { mode: 'mobile', zoom: 0.9 };
    }
}
